<template>
       <div v-show="isshowareaanim" class="p1_areaanim bg">
       </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import  {playbgmusic,stopbgmusic,resourcepath} from '@/commonjs/commonfn.js'
import store from '@/store/'
export default {
  name: 'areaanim',
  data() {
    return {
      "resourcepath":resourcepath,
      "isshowareaanim":0,
    }
  },
  mounted() {
    
   
  },
  methods: {
    showareaanim(){
      this.isshowareaanim=1;
      this.initAnimFn();
    },
    initAnimFn(){
         var p1_areaanimxiayutag = 0;
          var p1_areaanimxiayutimer;
         p1_areaanimxiayutimer = setTimeout(function() {
            p1_areaanimxiayutag++;
            var ywidth = $('.p1_areaanim').width();
            var tops = $('.p1_areaanim').offset().top;
            var yheight = $('.p1_areaanim').height();
            var leftsuiji = RandomNumBoth(30, ywidth - 30);
            var suijixue = RandomNumBoth(3, 4);
            var suijiwdith = RandomNumBoth(10, 30);
            var yudi = '<img  id="p1_areaanimxiayutag' + p1_areaanimxiayutag + '" style="left:' + leftsuiji + 'px;width:'+suijiwdith+'%; " p1_areaanimxiayutag="' + p1_areaanimxiayutag + '"  class="p1_areaanim_areaanimitem2 xiayu1" src=' + resourcepath + '/images/1/p1_areaanim_areaanimitem' + suijixue + '.png />';
            $(".p1_areaanim").append(yudi);
            this.initAnimFn();
            var p1_areaanim_areaanimitem2length = $('.p1_areaanim_areaanimitem2').length;
            if (p1_areaanim_areaanimitem2length >= 10) {
                $(".p1_areaanim_areaanimitem2:lt(3)").remove();
            }
        }, 1000)
    }
  },
  computed: {
    ...mapState(['suodingtipcss', 'yujiazaicss', 'sharetipcontainercss', 'morentanchuangcss', 'chuangtitle', 'fn', 'jindu', 'starcss', 'isalljiazai','isplaybgmusic']),
  }
}

</script>
<style scoped>
.p1_areaanim_areaanimitem2{
  position: absolute;
}

    
</style>


// WEBPACK FOOTER //
// src/components/areaanim.vue